"use client";

import { useEffect, useState } from "react";

import { getUserCountryCode } from "@/data/auth/queries/getUserCountryCode";

export function CloudflareAlertES() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const countryCode = await getUserCountryCode();

      if (countryCode === "ES") {
        setShowBanner(true);
      }
    };

    fetchData();
  }, [setShowBanner]);

  if (!showBanner) {
    return null;
  }

  return (
    <div className="bg-primaryLight px-6 py-2.5 sm:px-3.5">
      <p className="mx-auto w-fit text-sm leading-6 text-gray-900">
        In Spain, access to our infrastructure provider Cloudflare may be
        temporarily blocked during La Liga matches. This could affect service
        availability.
      </p>
    </div>
  );
}
